import { useEffect, useRef } from "react";
import { FieldValues, Path, UseFormReturn, useWatch } from "react-hook-form";
import { isDayjs } from "dayjs";

type TUseTriggerValidateProps<T extends FieldValues> = {
  methods: UseFormReturn<T, object, T>;
  name: Path<T>;
  triggerFields: Path<T>[];
};

export const useTriggerValidate = <T extends FieldValues>({ methods, name, triggerFields }: TUseTriggerValidateProps<T>) => {
  const { control, trigger } = methods;
  const value = useWatch({ control, name });
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip validation on first render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Skip trigger when value is an invalid Dayjs (e.g. user deleted YYYY/MM/DD partially)
    if (isDayjs(value) && !value.isValid()) return;
    triggerFields.forEach((field) => {
      trigger(field);
    });
  }, [value]);
};
